module.exports = __webpack_public_path__ + "img/thunder-2-blue.b2d046e6.svg";